<template>
  <el-dialog
    :title="$t('withholdIntegral.applyWithdrawal')"
    :visible.sync="dialogVisible"
    width="50%"
    center>
    <div class="ibox-content">
      <el-form :model="withholdIntegralInfo" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('withholdIntegral.totalPoints')">
              <el-input 
                v-model="withholdIntegralInfo.amount" 
                :placeholder="$t('withholdIntegral.requiredTotalPoints')"
                disabled>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('withholdIntegral.withdrawalPoints')" prop="applyAmount">
              <el-input 
                v-model="withholdIntegralInfo.applyAmount" 
                :placeholder="$t('withholdIntegral.requiredWithdrawalPoints')">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('withholdIntegral.applicant')" prop="applyUserName">
              <el-input 
                v-model="withholdIntegralInfo.applyUserName" 
                :placeholder="$t('withholdIntegral.requiredApplicant')">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('withholdIntegral.applicantPhone')" prop="applyUserTel">
              <el-input 
                v-model="withholdIntegralInfo.applyUserTel" 
                :placeholder="$t('withholdIntegral.requiredApplicantPhone')">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('withholdIntegral.bankAccount')" prop="bankNum">
              <el-input 
                v-model="withholdIntegralInfo.bankNum" 
                :placeholder="$t('withholdIntegral.requiredBankAccount')">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('withholdIntegral.accountName')" prop="bankNumName">
              <el-input 
                v-model="withholdIntegralInfo.bankNumName" 
                :placeholder="$t('withholdIntegral.requiredAccountName')">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('withholdIntegral.openingBank')" prop="bankName">
              <el-input 
                type="textarea"
                v-model="withholdIntegralInfo.bankName" 
                :placeholder="$t('withholdIntegral.requiredOpeningBank')">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('withholdIntegral.applicationNote')" prop="remark">
              <el-input 
                type="textarea"
                v-model="withholdIntegralInfo.remark" 
                :placeholder="$t('withholdIntegral.requiredApplicationNote')">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('withholdIntegral.cancel') }}</el-button>
      <el-button type="primary" @click="submit">{{ $t('withholdIntegral.submit') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { applyIntegralWithdrawal } from '@/api/shop/integralApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'WithholdIntegral',
  data() {
    return {
      dialogVisible: false,
      withholdIntegralInfo: {
        integralId: '',
        integralName: '',
        shopId: '',
        amount: '',
        applyAmount: '',
        applyUserName: '',
        applyUserTel: '',
        remark: '',
        bankNum: '',
        bankNumName: '',
        bankName: ''
      }
    }
  },
  methods: {
    open(data) {
      this.resetForm()
      this.withholdIntegralInfo = Object.assign({}, data)
      this.withholdIntegralInfo.applyAmount = data.amount
      this.withholdIntegralInfo.shopId = getShopId()
      this.dialogVisible = true
    },
    resetForm() {
      this.withholdIntegralInfo = {
        integralId: '',
        integralName: '',
        shopId: '',
        amount: '',
        applyAmount: '',
        applyUserName: '',
        applyUserTel: '',
        remark: '',
        bankNum: '',
        bankNumName: '',
        bankName: ''
      }
    },
    async submit() {
      try {
        const res = await applyIntegralWithdrawal(this.withholdIntegralInfo)
        if (res.code === 0) {
          this.$emit('notify')
          this.$message.success(this.$t('withholdIntegral.submitSuccess'))
          this.dialogVisible = false
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('Failed to apply integral withdrawal:', error)
        this.$message.error(this.$t('withholdIntegral.submitFailed'))
      }
    }
  }
}
</script>

<style scoped>
.ibox-content {
  padding: 15px 20px 20px 20px;
}
</style>